import { AdditionalKycRequestState } from '#src/__generated__/globalTypes.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';

export const useHasAdditionalKycRequestOpen = () => {
  const { currentUser } = useCurrentUserContext();
  return (currentUser?.mangopayUser?.additionalKycRequests || []).some(
    request =>
      [
        AdditionalKycRequestState.CREATED,
        AdditionalKycRequestState.VALIDATION_ASKED,
      ].includesValue(request.aasmState)
  );
};
